import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';

import Select from '../ui/Select';
import ApplicationContext from '../ApplicationContext';
import { MoveType } from '../ifmsTypes';
import { ComboParamsBase, FmsComboType } from '../fms.core/constants';

function MoveTypeDropDown({
  value,
  onChange = () => {},
  disabled,
  addAll = false,
  addBlank = true,
  name=undefined,
  maxLength = undefined,
}: {
  value:string|null|undefined,
  onChange?:(x:string|null, m:MoveType|null) => void,
  disabled?: boolean,
  addAll?: boolean, // Is ALL offered as an option
  addBlank?: boolean, 
  name?:string|undefined,
  maxLength?: number|undefined,
}) {
  const appContext = useContext(ApplicationContext);

  const [data, setData] = useState<Array<any>>([]);

  async function fetchData(api:any) {
    //const data = await api.getCodesOceanMoveTypes() as Array<MoveType>;
    //setData(data.filter(x => !x.inactive));
    var base = new ComboParamsBase();
    base.comboType = FmsComboType.MoveType;
    const data = await api.loadCodeData([base]);
    if (data && data.length > 0) {
      setData(data[0].items);
    }
    //const filteredData = data.filter(x => !x.inactive);

    //if ((value === null || value === undefined) && filteredData && filteredData.length > 0) {
      //onChange(filteredData[0].moveType, filteredData[0]);
    //}
  }

  useEffect(() => {
      fetchData(appContext.api);
      return () => {
         setData([]);
      }
  },
   // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  function handleChange(e:any) {
    const moveType = !!e && !!e.target && !!e.target.value && data ? data.find(x => x.id === e.target.value) as MoveType : null;
    onChange(e.target.value, moveType);
  }

  // let displayData = value === null || value === undefined
  //   ? ['', ...data]
  //   : data;

    let displayData = [...data];
    displayData = addBlank ? ['', ...displayData] : displayData;
    displayData = addAll ? ['ALL', ...displayData] : displayData;
    
  return (
    <Select
      // value={value || ''}
      name={name}
      value={(value === null || value === undefined) ? '' : value}
      onChange={handleChange}
      disabled={disabled}
      items={
        displayData.map(x => ({ value: x, label: x }))
      }
      maxLength={maxLength}
    />
  );
}

MoveTypeDropDown.defaultProps = {
  onChange: () => {},
  disabled: false,
  dark: false,
};

MoveTypeDropDown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  dark: PropTypes.bool.isRequired,
};

export default React.memo(MoveTypeDropDown);
